<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "App",
    components: {},
    // 接下来的使用就跟之前一样，初始化图表，设置配置项
};
</script>

<style lang="less">
#app {
    font-family: "思源黑体", Avenir, Helvetica, Arial, sans-serif;
    width: 100%;
    height: 100%;
}
</style>
